import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FxVideoCompressModalComponent } from './fx-video-compress-modal/fx-video-compress-modal.component';
import {DwFormItemsModule, FrameworkUIModule} from '@webdpt/framework';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {NgQuicksilverModule} from 'ng-quicksilver';
import { FxVideoCompressModalLiteComponent } from './fx-video-compress-modal-lite/fx-video-compress-modal-lite.component';

@NgModule({
  declarations: [
    FxVideoCompressModalComponent,
    FxVideoCompressModalLiteComponent
  ],
  imports: [
    CommonModule,
    DwFormItemsModule,
    ReactiveFormsModule,
    TranslateModule,
    FrameworkUIModule,
    NgQuicksilverModule
  ]
})
export class FxFfmpegWasmModule { }
